import { createBrowserRouter, replace } from 'react-router';
import { App } from './App.tsx';
import { BngIpLookupPage } from './modules/bng-ip-lookup/BngIpLookupPage.tsx';
import { SubscriberPage } from './modules/subscribers/SubscriberPage.tsx';
import { UsocPage } from './modules/usoc/UsocPage.tsx';

export const router = createBrowserRouter([
  {
    path: '/',
    Component: App,
    children: [
      { index: true, loader: () => replace('/subscribers') },
      { path: 'subscribers', Component: SubscriberPage },
      { path: 'bng-ip-lookup', Component: BngIpLookupPage },
      { path: 'usoc', Component: UsocPage },
    ],
  },
  {
    path: '*',
    loader: () => replace('/subscribers'),
  },
]);
